import ErrorReporter from 'scripts/infrastructure/error_reporter';
import { isKnownCompositionContentType } from 'models/composition/composition_content_from_js';

// A draft written by a newer (or rolled-back) desktop must not hide every other draft on the customer.
export default function hasKnownContentType(dto) {
  const type = dto.content && dto.content.type;
  if (isKnownCompositionContentType(type)) return true;

  ErrorReporter.reportMessage(`skipped composition with unknown content type [${type}]`, {
    extra: { compositionId: dto.id },
  });
  return false;
}
